import React from 'react';
import { useLocation } from "react-router-dom";
import { VegaFlex, VegaInputSelect, VegaInput } from "@heartlandone/vega-react";
import { FILTER_CONTROL_CATEGORY, ROUTES_PATH } from 'Chore/Constants';

const FilterGroup = ({ options = [] }) => {
  const location = useLocation();

  const _renderInputs = () => {
    return options.map(({
      type = FILTER_CONTROL_CATEGORY.INPUT,
      isRequired = false,
      placeholder = '',
      source,
      onChangeHandler = () => {},
      value
    }, index) => {
      if (type === FILTER_CONTROL_CATEGORY.INPUT) {
        return <VegaInput
          key={index}
          prefixIcon='fa-duotone fa-magnifying-glass'
          required={isRequired}
          placeholder={placeholder}
          onVegaChange={onChangeHandler}
          value={value}
          size='small'
        />
      } else if (type === FILTER_CONTROL_CATEGORY.SELECT) {
        return <VegaInputSelect
          key={index}
          required={isRequired}
          placeholder={placeholder}
          vegaDropdownProps={{searchable: false}}
          source={source}
          onVegaChange={onChangeHandler}
          value={value}
          size='small'
        />
      } else {
        return null;
      }
    })
  }

  return (
    <VegaFlex gap={'size-16'} style={{ width: location.pathname === ROUTES_PATH.ROOT ? '85%' :'90%' }}>
      {_renderInputs()}
    </VegaFlex>
  );
}

export default FilterGroup;
